import { StyleSheet } from 'aphrodite';
import { THEME } from '../../Theme/theme';

export const styleSheet = StyleSheet.create({
	selectImageTabContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		height: '100%',
	},
	imagesRow: {
		display: 'flex',
		flexDirection: 'row',
		gap: THEME.spacing.md,
		flex: 1,
	},
	image: {
		width: 160,
		height: 160,
		objectFit: 'cover',
		borderRadius: THEME.common.borderRadius,
	},
	imageContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		alignItems: 'center',
	},
	checkboxContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: THEME.spacing.sm,
		alignItems: 'center',
	},
	checkboxLabel: {
		fontSize: 12,
		fontWeight: 500,
	},
	modalActionsContainer: {
		display: 'flex',
		justifyContent: 'flex-start',
		alignItems: 'center',
		gap: THEME.spacing.sm,
		paddingTop: THEME.spacing.md,
	},
});
